export default __webpack_public_path__ + "static/media/instagram.bc6dba81.svg";